import { defaultDate, onlyDateWithFullTear } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'

export default {
  props: {
    auto: Object,
    readOnly: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      readonly: false,
    }
  },
  methods: {
    changedElement(data) {
      for (let d in data) {
        this.returnData[d] = data[d]
      }
      this.changed()
    },
    changed() {
      // TODO валидация формы
      if (this.returnData.sts_date) {
        const sts_date = getDateOfCertainFormat(
          this.returnData.sts_date,
          defaultDate,
          1,
        )

        this.$emit('changed', { ...this.returnData, sts_date })
      } else {
        this.$emit('changed', this.returnData)
      }
    },
    setDefaultData(data) {
      for (let key in data) {
        if (this.returnData[key] !== undefined) {
          if (key === 'sts_date' && data[key]) {
            data[key] = getDateOfCertainFormat(data[key], onlyDateWithFullTear)

            if (data[key].length > 10) {
              data[key] = null
            }
          }
          this.returnData[key] = data[key]
        }
      }
    },
  },
  watch: {
    auto: {
      immediate: true,
      handler(newVal) {
        this.setDefaultData(newVal)
      },
    },
    readOnly: {
      immediate: true,
      handler(newVal) {
        this.readonly = newVal
      },
    },
  },
}
